<template>
  <!-- Tipo de pensión -->
  <div class="col">
    <div class="form-group required">
      <ValidationProvider
        name="syllabus_tuition_id"
        rules="required"
        v-slot="{ valid, errors }"
      >
        <label class="control-label" for="syllabus_tuition_id"
          >Tipo de pensión</label
        >
        <b-form-select
          v-model="syllabusTuitionId"
          :options="syllabusTuitionsOptions"
          value-field="id"
          text-field="name"
          id="syllabus_tuition_id"
          size="sm"
        >
          <b-form-select-option :value="null"
            >--Seleccione un tipo de pension--</b-form-select-option
          >
        </b-form-select>
        <b-form-invalid-feedback :state="valid">{{
          errors[0]
        }}</b-form-invalid-feedback>
      </ValidationProvider>
      <small v-if="data !== null"
        >1ra Bs. {{ data.first_tuition_price | currency }} - 2da Bs.
        {{ data.second_tuition_price | currency }}</small
      >
    </div>
  </div>
</template>
<script>
import {
  BFormInvalidFeedback,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";
import { extend } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
//services
import SyllabusTuitions from "@/plugins/services/syllabus-tuitions";

export default {
  name: "StudentSyllabusTuition",
  components: { BFormInvalidFeedback, BFormSelect, BFormSelectOption },
  props: {
    syllabus_id: { type: Number, default: null },
    value: { type: Number, default: 0 },
  },
  data() {
    return {
      syllabusTuitionId: null,
      addLoader: false,
      syllabusTuitionsOptions: [],
      dataEmit: { data: null },
      loadData: false,
      data: null,
    };
  },
  computed: {
    computedForm() {
      return this.$refs.form;
    },
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });
  },
  mounted() {
    if (this.syllabus_id) this.getSyllabusTuitions(this.syllabus_id);
  },
  watch: {
    value(val) {
      this.syllabusTuitionId = val;
    },
    loadData(val) {
      this.syllabusTuitionId = this.value;
    },
    syllabus_id(syllabus_id) {
      if (syllabus_id) this.getSyllabusTuitions(this.syllabus_id);
    },
    syllabusTuitionId(id) {
      this.search(id);
    },
  },
  methods: {
    getSyllabusTuitions(syllabus_id) {
      this.syllabusTuitionId = null;
      SyllabusTuitions.selectAll(syllabus_id)
        .then((res) => {
          this.syllabusTuitionsOptions = res.data;
          this.loadData = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search(id) {
      let syllabus_tuition = this.syllabusTuitionsOptions.find(
        (st) => st.id == id
      );
      this.data = syllabus_tuition ? syllabus_tuition : null;
      this.dataEmit.data = this.data;
      this.$emit("syllabus_tuition", this.dataEmit);
    },
  },
};
</script>
